import styled from 'styled-components';
import { Icon } from '../Icon';
import { media } from '../../../utilities/media';
import { GRID_UNIT } from '../../../utilities/grid';
const selectColor = {
    loading: 'cyan',
    error: 'negative',
    info: 'neutral',
    success: 'positive',
    warning: 'yellow',
};
export const AlertWrapper = styled.div `
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  background: ${({ theme, type }) => selectColor[type] ? theme.palette[selectColor[type]].lighter : 'none'};
  border-radius: ${({ withoutBorder }) => withoutBorder === 'both'
    ? '0'
    : withoutBorder === 'bottom'
        ? '4px 4px 0 0'
        : withoutBorder === 'top'
            ? '0 0 4px 4px'
            : '4px'};
  padding: ${2 * GRID_UNIT}px;
  ${media.mobileLarge `
    flex-flow: row nowrap;
    align-items: flex-start;
  `}
`;
export const StyledIcon = styled(Icon) `
  width: 24px;
  height: 24px;
`;
export const AlertIcon = styled.div `
  width: 24px;
  height: 24px;
  margin-bottom: ${GRID_UNIT}px;
  ${media.mobileLarge `
    margin-right: ${2 * GRID_UNIT}px;
    margin-bottom: 0;
  `}
  flex-shrink: 0;
`;
export const AlertAction = styled.div `
  display: flex;
  flex-flow: row nowrap;
  margin-top: ${GRID_UNIT}px;
  ${media.mobileLarge `
    flex: 0 0 25%;
    justify-content: flex-end;
    margin-left: ${2 * GRID_UNIT}px;
    margin-top: 0;
  `}
`;
export const AlertContent = styled.div `
  display: flex;
  flex: 1 0;
  flex-direction: column;
`;
//# sourceMappingURL=Alert.styles.js.map